<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن گروه کاربری</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.name.val" :description="form.name.inv" label="نام" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect v-model="form.is_active.val" :description="form.is_active.inv" label="وضعیت"
                                    :options="[{value: 'true', label:'فعال'}, {value: 'false', label: 'غیرفعال'}]" 
                                    placeholder="انتخاب کنید" @change="form.is_active.val=$event.target.value" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
                name: {val: '', inv: '', v: { req: true, max: 64 }},
                is_active: {val: '', inv: '', v: {req: true, max: 8 }},
            },
            disable: false,
        }
    },
    methods: {
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                this.axios.post('user_groups/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_create_user_group == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
